import { el } from 'redom';

import './index.scss';

class CodeEditorInputBox {

  constructor(configuration) {

    this.value = configuration.value;
    this.onChange = configuration.onChange;

    this.silent = false;
    this.errored = false;
    this.editor = null;
    this.codeEditorContainer = el('.code-editor-container');
    this.errorLabel = this.renderError();

    this.el = el('.code-editor-input-box-main', {
      class: 'field-input-and-error'
    }, [this.codeEditorContainer, this.errorLabel]);

  }

  renderError() {

    return el('label.error-message');

  }

  buildCodeEditorOptions() {

    const options = {
      useWorker: false,
      autoScrollEditorIntoView: true,
      copyWithEmptySelection: true,
      enableAutoIndent: true,
      tabSize: 2,
      maxPixelHeight: 300,
      placeholder: `
      function submittedFormHandler(submission) {
        // submission.formId - form id
        // submission.data - form data
        // submission.apiCallResponse - Response of the API call, if the form data is expected to be sent to an API.
        // submission.apiCallResponse.statusCode - HTTP status code
        // submission.apiCallResponse.body - API call response body
        // submission.apiCallResponse.headers - API call response headers
        // Notifier.info('Form is submitted successfully!')
        // Notifier.error('Uh oh! There some error. Please try another time');
      }`
    };

    return options;

  }

  renderEditor() {

    this.editor = ace.edit(this.codeEditorContainer, this.buildCodeEditorOptions());
    ace.config.set('basePath', 'https://cdnjs.cloudflare.com/ajax/libs/ace/1.15.2');
    this.editor.setTheme('ace/theme/monokai');
    this.editor.session.setMode('ace/mode/js');

    this.editor.setValue(this.value);

    this.editor.session.on('change', this.handleCodeEditorChange.bind(this));

  }

  handleCodeEditorChange(event, editor) {

    if (this.silent === true) {
      return;
    }

    this.value = editor.getValue();

    this.onChange(this.value);

  }

  setValue(value) {

    this.silent = true;

    this.editor.setValue(value);

    this.silent = false;

  }

  setError(errorMessage) {

    this.errored = true;

    this.error.textContent = errorMessage;

  }

  clearError() {

    if (this.errored === false) {
      return;
    }

    this.errored = false;

    this.error.textContent = '';

  }

  empty() {

    this.value = '';

    this.editor.setValue(this.value);

  }

  reset() {

    this.empty();
    this.clearError();

  }

  getValue() {

    return this.value;

  }

  focus() {

    this.editor.focus();

  }

  disable() {

    this.editor.setReadonly(true);

  }

  enable() {

    this.editor.setReadonly(false);

  }

  setAttr(attributes) {

    // TODO: Implement setAttr

  }

  setReadOnly(readOnly) {

    this.editor.setReadOnly(readOnly);

  }

  hide() {

    this.el.classList.add('hidden');

  }

  show() {

    this.el.classList.remove('hidden');

  }

  onmount() {

    this.renderEditor();

  }

}

export default CodeEditorInputBox;